//@flow
import * as Immutable from 'immutable';

import { AmountTransaction } from 'common/models/flow/AmountTransaction';
import type { AmountTransactionModelType } from 'common/models/flow/AmountTransaction';

import { Amount } from './Amount';

class InternalAmountTransaction extends AmountTransaction {
    static fromJS(json: AmountTransactionModelType): InternalAmountTransaction {
        const state: Object = Object.assign({}, json);
        state.amount = Amount.fromJS(state.amount);
        return new this(Immutable.Map(state));
    }

    getExchangeTypeText(): string {
        const transactionType = this.exchangeType;
        switch (transactionType) {
            case 'NONE':
                return 'PAID';
        }
        return transactionType;
    }

    get amount(): Amount {
        return this._state.get('amount');
    }
}

export { InternalAmountTransaction as AmountTransaction };
